import {
  advanceSequence,
  ARPEGGIO_FINGER,
  arpeggioPitchClasses,
  invertVoicing,
  noteDefToMidi,
  raiseOctave,
  SCALES,
  skalaTonklassen,
  skalaVon,
  skalenNach,
  TONLEITER_STUFEN,
} from './index';

const musicBridge = Object.freeze({
  noteDefToMidi, raiseOctave, invertVoicing, advanceSequence,
  ARPEGGIO_FINGER, arpeggioPitchClasses,
  SCALES, TONLEITER_STUFEN, skalaVon, skalaTonklassen,
  skalenNach,
});

Object.assign(globalThis, {
  PiandojoMusic: musicBridge,
  SCALES,
  TONLEITER_STUFEN,
  skalaVon,
  skalaTonklassen,
  skalenNach,
});
